export var ErrorType;
(function (ErrorType) {
    ErrorType["WARNING"] = "warning";
    ErrorType["INFO"] = "info";
    ErrorType["ERROR"] = "error";
})(ErrorType || (ErrorType = {}));
